import React, { useState } from "react";
import { Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { GoHome } from "react-icons/go";
import Edition from "../../Config/edition.json";
import moment from "moment";
import { DatePicker, Modal, Tabs } from "antd";
import dayjs from "dayjs";
import { RiArrowDropDownLine } from "react-icons/ri";

const SubHeader = (props: any) => {
  const navigate = useNavigate();
  const format = "YYYY-MM-DD";
  const [isModalVisible, setIsModalVisible] = useState(false);

  const oneditionChange = (edit: any) => {
    let url: any = `/?date=&edition=${edit}`;
    navigate(url);
    // Close modal on mobile after selection
    setIsModalVisible(false);
  };

  const onClickHome = (edit: any) => {
    let url: any = `/?date=${moment(new Date()).format(format)}&edition=`;
    navigate(url);
  };

  const onDateChange = (date: any, string: any) => {
    let url: any = `?date=${moment(string).format(format)}&edition=`;
    navigate(url);
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const closeModal = () => {
    setIsModalVisible(false);
  };
  // Find current edition name for mobile button
  const currentEdition = Edition?.find((item) => item.value === props.edition);
  const currentEditionName = currentEdition ? currentEdition.name : "Editions";

  // Tab items for desktop view
  const tabItems = Edition?.map((item: any) => ({
    key: item.value,
    label: item.name,
  }));

  return (
    <div className="Edition-box1">
      <div className="Edition">
        <Container fluid={false}>
          <div className="Edition-box">
            <div
              className={
                props.edition === "" || props.edition === null
                  ? "Edition-item active"
                  : "Edition-item"
              }
              onClick={() => onClickHome("")}
            >
              <div className="Edition-txt1">
                <GoHome size={20} />
              </div>
            </div>
            <div className="Edition-item2">
              <DatePicker
                value={dayjs(props?.date, format)}
                defaultValue={dayjs(props?.date, format)}
                bordered={false}
                allowClear={false}
                onChange={(value: any, string: any) =>
                  onDateChange(value, string)
                }
              />
            </div>
            {/* Desktop editions - Tabs with dropdown */}
            <div className="Edition-desktop-tabs">
              <Tabs
                activeKey={props.edition || ""}
                onChange={oneditionChange}
                className="Edition-tabs"
                moreIcon={<RiArrowDropDownLine size={24} />}
                items={tabItems}
              />
            </div>
            {/* Mobile editions button */}
            <div className="Edition-mobile-button" onClick={showModal}>
              <div className="Edition-mobile-btn-content">
                <RiArrowDropDownLine
                  size={24}
                  style={{ marginBottom: "3px" }}
                />
                <span className="Edition-mobile-btn-text">
                  {currentEditionName}
                </span>
              </div>
            </div>
          </div>
        </Container>
      </div>
      {/* Mobile Modal */}
      <Modal
        title="Select Edition"
        open={isModalVisible}
        onCancel={closeModal}
        footer={null}
        className="Edition-modal"
        centered
      >
        <div className="Edition-modal-content">
          {Edition?.map((item: any) => {
            return (
              <div
                key={item.value}
                className={
                  props.edition === item.value
                    ? "Edition-modal-item active"
                    : "Edition-modal-item"
                }
                onClick={() => oneditionChange(item.value)}
              >
                <div className="Edition-modal-txt">{item.name}</div>
              </div>
            );
          })}
        </div>
      </Modal>
    </div>
  );
};

export default SubHeader;
